<atlas-offcanvas
	(atlas-offcanvas-close)="closeOffCanvas()"
	[open]="openOffCanvas"
	header="{{
		invoiceError?.error?.type === 'InvoiceErrorSefaz'
			? ('INVOICE_VALIDATION_ERROS.TITLE_SEFAZ' | translate)
			: ('INVOICE_VALIDATION_ERROS.TITLE' | translate)
	}}"
	id="offcanvas-invoice-erros"
	class="off-canvas-z-index"
	gap="6"
>
	<atlas-layout gap="3" inline>
		<atlas-icon name="alert-triangle" size="6x" theme="warning">
		</atlas-icon>
		<atlas-text>
			{{ "INVOICE_VALIDATION_ERROS.DESCRIPTION" | translate }}
		</atlas-text>
	</atlas-layout>

	<atlas-layout>
		<atlas-card background="light" class="panel-off-canvas">
			<ol class="errors-list">
				<li
					*ngFor="
						let error of invoiceError?.error?.errors;
						let i = index
					"
				>
					{{ error.code ? error.code + " - " : "" }}
					{{ error.message }}
				</li>
			</ol>
		</atlas-card>
	</atlas-layout>
	<atlas-button
		slot="actions"
		description="{{ 'INVOICE_VALIDATION_ERROS.CLOSE_BUTTON' | translate }}"
		(click)="closeOffCanvas()"
	>
	</atlas-button>
</atlas-offcanvas>
